import { UNIVERSAL_ID } from '@shared/constants/segment'
import Cookies from 'js-cookie'
import { isOnServer } from '@shared/constants/util'
import { type User } from '@/features/account/services/User/types'
import { type AristotleExperiments, type ExperimentType } from '@shared/types/experiments'
import { type RequestCookies } from '@shared/request_type'

const getUniversalIdFromSSRCookies = (cookies: RequestCookies) => {
  const universal_id = cookies[UNIVERSAL_ID]
  if (universal_id) return universal_id
  return ''
}

type UniversalIdForStoreParams = {
  serverCookies?: RequestCookies
  user?: User
}

export const getUniversalId = (params?: UniversalIdForStoreParams): string => {
  const { user, serverCookies } = params ?? {}
  if (user?.universal_id) return user.universal_id
  if (isOnServer() && serverCookies) {
    return getUniversalIdFromSSRCookies(serverCookies)
  } else return Cookies.get(UNIVERSAL_ID) || ''
}

export const hasShiptEmail = (email?: string | null) => {
  return email?.includes('@shipt.com') ?? false
}

export const getExperimentStatus = (
  experiments: AristotleExperiments | undefined,
  key: ExperimentType,
) => {
  const experiment = experiments?.[key]
  const active = Boolean(
    experiment?.value && experiment.value !== 'control' && experiment.value !== 'off',
  )

  return { value: experiment?.value, active }
}
